export default __webpack_public_path__ + "static/N0057-6b917dde589f1d1a830a328c0fd11145.png";